/**
 * IpSelectItem[] → CategoryItem[] 변환 (순차 선택 패턴)
 *
 * depthLabels 별로 섹션을 생성하고, selectedIndices에 따라 다음 depth의 아이템을 표시
 * - 학년 섹션: items (중등, 고등...)
 * - 카테고리 섹션: 선택된 학년의 children
 * - 시리즈 섹션: 선택된 카테고리의 children
 * - 교재 섹션: 선택된 시리즈의 children (leaf)
 */ export const convertToCategories = (items, depthLabels, selectedIndices)=>{
    const sections = [];
    let currentItems = items;
    for(let depth = 0; depth < depthLabels.length; depth++){
        var _selectedItem_children;
        // 현재 depth에 아이템이 없으면 중단
        if (!currentItems || currentItems.length === 0) break;
        // depth별 섹션 생성 (children 없이 flat하게)
        sections.push({
            categoryId: "depth-".concat(depth),
            title: depthLabels[depth],
            productId: "",
            items: currentItems.map((item, index)=>({
                    categoryId: "".concat(depth, "-").concat(index),
                    title: item.label,
                    productId: item.sourceId || "",
                    items: undefined
                }))
        });
        // 현재 depth에서 선택된 항목이 없으면 다음 depth 표시 안함
        const selectedIndex = selectedIndices[depth];
        if (selectedIndex === undefined) break;
        // 선택된 항목의 children을 다음 depth 아이템으로 설정
        const selectedItem = currentItems[selectedIndex];
        if (!(selectedItem === null || selectedItem === void 0 ? void 0 : (_selectedItem_children = selectedItem.children) === null || _selectedItem_children === void 0 ? void 0 : _selectedItem_children.length)) break;
        currentItems = selectedItem.children;
    }
    return sections;
};
/**
 * categoryId를 depth와 index로 파싱
 * @returns 파싱된 depth와 index, 유효하지 않은 형식이면 null
 */ export const parseCategoryId = (categoryId)=>{
    const parts = categoryId.split("-");
    if (parts.length !== 2) return null;
    const [depth, index] = parts.map(Number);
    if (Number.isNaN(depth) || Number.isNaN(index)) return null;
    return {
        depth,
        index
    };
};
